<template>
    <div class="box">
        <div class="campaign-form-title mb-10">
            Your File Uploads
        </div>

        <div v-if="proposal.files.length" class="mb-15">
            <div v-for="file in proposal.files">
                <div class="level mb-5">
                    <div class="level-left truncate">
                        {{ file.label }}
                    </div>

                    <div class="level-right">
                        <a class="delete" @click="handleFileDelete(file.id)"></a>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="mb-15">
            Upload media files here.
        </div>

        <button class="button is-primary" :disabled="$root.loading('dropzone.uploading')" @click="toggleDropzone">
            <span v-if="show_dropzone">Finish Uploading</span>
            <span v-else>Upload Files</span>
        </button>

        <dropzone
            v-if="show_dropzone"
            class="mt-15"
            :url="`/campaigns/proposal/${proposal.id}/files/upload`"
            @uploaded="handleFileUploaded"
        />
    </div>
</template>

<script>
    import Dropzone from '../../interface/elements/Dropzone.vue';

    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'ProposalFiles',

        /**
         * The used components
         *
         * @type {Object}
         */
        components: {
            Dropzone
        },

        /**
         * The component props
         *
         * @type {Object}
         */
        props: {
            /**
             * The proposal
             */
            proposal: {
                type:     Object,
                required: true
            }
        },

        /**
         * The component data
         *
         * @returns {Object}
         */
        data() {
            return {
                /**
                 * Whether or not to show the dropzone
                 */
                show_dropzone: false
            };
        },

        /**
         * The component methods
         *
         * @type {Object}
         */
        methods: {
            /**
             * Show/hide the dropzone
             */
            toggleDropzone() {
                this.show_dropzone = !this.show_dropzone;
            },

            /**
             * Handle the file uploaded event
             *
             * @param {Object} file
             */
            handleFileUploaded(file) {
                this.proposal.files.push(file);
            },

            /**
             * Delete a file
             *
             * @param {Number} id
             */
            handleFileDelete(id) {
                this.proposal.files = this.proposal.files.filter(file => file.id !== id);

                this.$http.post(`/campaigns/proposal/${this.proposal.id}/files/${id}/delete`)
                    .catch(() => this.$notifyError('Could not delete a file, please try again or contact support'))
                ;
            }
        }
    }
</script>